// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oblh","content":"styles_content__3Ag4M","tableWrap":"styles_tableWrap__2o_aM"};